import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { EmailBlockModel } from "@app/workflow-common/services/models/EmailBlockModel";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
import { from } from "rxjs";
import { map } from "rxjs/operators";
import { CommonDataSource } from "@app/workflow-common/services/CommonDataSource";
var EmailBlockWidgetComponent = /** @class */ (function () {
    function EmailBlockWidgetComponent(formBuilder, workflowService) {
        this.formBuilder = formBuilder;
        this.workflowService = workflowService;
        this.isConditional = false;
        this.conditionalColName = '';
        this.close = new EventEmitter();
        this.isLoading = true;
        this.isSMTPEnabled = false;
        this.fromEmailAddressesList = [];
        this.emailBlockData = {};
        this.select2ConfigToEmail = {};
        this.select2ConfigOtherEmail = {};
        this.usersList = [];
        this.emailTagsList = [];
        this.emailUsersList = [];
        this.emailCustomList = [];
        this.showCC = false;
        this.showBCC = false;
        this.isFormSubmitted = false;
        this.selectedEmailInputs = {};
        this.inputModel = undefined;
        this.showDeleteBtn = false;
    }
    EmailBlockWidgetComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var blockObject, modelData, formGroupConfig;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.emailBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
                        this.emailTagsList = this.dagSourceModel.getEmailAddressTagsByType(this.workflowType, this.objectName, this.screenName);
                        blockObject = tslib_1.__assign({}, this.blockObject);
                        modelData = blockObject['model'] ? blockObject['model'] : undefined;
                        if (modelData) {
                            this.showDeleteBtn = true;
                        }
                        this.inputModel = new EmailBlockModel(modelData);
                        this.makeEmailAddressDropdownData();
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.usersList.forEach(function (user) {
                            _this.emailUsersList.push({
                                id: parseInt(user.id),
                                text: user.username,
                                name: 'USERS'
                            });
                        });
                        if (!this.isSMTPEnabled) {
                            this.inputModel.fromEmail = '';
                        }
                        this.setToEmailSelect2Config();
                        formGroupConfig = {
                            fromEmail: new FormControl(this.inputModel.fromEmail),
                            templateId: new FormControl(this.inputModel.templateId, [Validators.required]),
                            toEmailTag: new FormControl(this.selectedEmailInputs['toEmailTag'], [Validators.required]),
                            ccEmailTag: new FormControl(this.selectedEmailInputs['ccEmailTag']),
                            bccEmailTag: new FormControl(this.selectedEmailInputs['bccEmailTag']),
                            subject: new FormControl(this.inputModel.subject),
                            message: new FormControl(this.inputModel.message),
                            templateName: new FormControl(this.inputModel.templateName),
                        };
                        if (this.isConditional) {
                            formGroupConfig['condition'] = this.formBuilder.group({});
                        }
                        this.form = this.formBuilder.group(formGroupConfig);
                        if (this.isSMTPEnabled) {
                            this.form.get('fromEmail').setValidators(Validators.required);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailBlockWidgetComponent.prototype.getData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.workflowService.getCommunicationTemplateConfig()
                .toPromise()
                .then(function (resp) {
                var data = resp.hasOwnProperty('data') ? resp['data'] : null;
                if (data) {
                    _this.isSMTPEnabled = data.smtpDetails.smtp;
                    if (_this.isSMTPEnabled) {
                        _this.fromEmailAddressesList = data.smtpDetails.smtpList;
                    }
                    _this.usersList = data.users;
                    resolve(true);
                }
            }, function (err) {
                reject(err);
                console.error(err);
            });
        });
    };
    EmailBlockWidgetComponent.prototype.setToEmailSelect2Config = function () {
        var select2Default = CommonDataSource.select2EmailDefaultConfig;
        this.select2ConfigToEmail = tslib_1.__assign({}, select2Default);
        this.select2ConfigToEmail['data'] = this.makeGroupEmailList('toAddress');
        if (this.emailBlockData['groupId'] != 'internalCommunications') {
            this.select2ConfigToEmail['formatNoMatches'] = function () {
                return 'Add a recipient\'s email by entering...';
            };
        }
        this.select2ConfigOtherEmail = tslib_1.__assign({}, select2Default);
        this.select2ConfigOtherEmail['data'] = this.makeGroupEmailList('ccAddress');
    };
    EmailBlockWidgetComponent.prototype.makeGroupEmailList = function (emailType) {
        if (emailType === void 0) { emailType = 'toAddress'; }
        var allEmailTag = [];
        var newItems = [];
        if ((emailType == 'ccAddress' || emailType == 'bccAddress' ||
            (emailType == 'toAddress' && this.emailBlockData['groupId'] == 'internalCommunications'))
            && this.emailUsersList && this.emailUsersList.length) {
            newItems.push(this.emailUsersList);
        }
        else if (emailType == 'toAddress' && this.emailBlockData['groupId'] == 'externalCommunications' && this.emailTagsList && this.emailTagsList.length) {
            newItems.push(this.emailTagsList);
        }
        if (this.emailCustomList.length) {
            newItems.push(this.emailCustomList);
        }
        var source = from(newItems);
        var tags = source.pipe(map(function (groupItems) {
            var _item = { text: '', children: [] };
            var cnt = 0;
            groupItems.forEach(function (group) {
                if (cnt === 0) {
                    _item.text = group.name;
                }
                _item.children.push({
                    id: group.id,
                    text: group.text
                });
                cnt++;
            });
            return _item;
        }));
        var subscribe = tags.subscribe(function (val) { return allEmailTag.push(val); });
        subscribe.unsubscribe();
        return allEmailTag;
    };
    EmailBlockWidgetComponent.prototype.setTemplateDetails = function (event, type) {
        this.form.get('templateId').setValue(event['templateId']);
        this.form.get('message').setValue(event['message']);
        this.form.get('subject').setValue(event['subject']);
        this.form.get('templateName').setValue(event['templateName']);
        this.inputModel.subject = event['subject'];
        this.inputModel.message = event['message'];
        this.inputModel.templateName = event['templateName'];
    };
    EmailBlockWidgetComponent.prototype.selectedEmailAddress = function (event, type) {
        if (event === void 0) { event = null; }
        if (type === void 0) { type = 'to'; }
        if (type == 'to') {
            this.form.get('toEmailTag').setValue(event);
        }
        else if (type == 'cc') {
            this.form.get('ccEmailTag').setValue(event);
        }
        else {
            this.form.get('bccEmailTag').setValue(event);
        }
    };
    EmailBlockWidgetComponent.prototype.save = function () {
        this.isFormSubmitted = true;
        var blockObject = tslib_1.__assign({}, this.blockObject);
        var _a = this.form.value, toEmailTag = _a.toEmailTag, ccEmailTag = _a.ccEmailTag, bccEmailTag = _a.bccEmailTag, condition = _a.condition, subject = _a.subject;
        blockObject.model = new EmailBlockModel(this.form.value);
        blockObject.model.toEmailTag = CommonDataSource.formattingEmailAddress(toEmailTag, this.emailTagsList, this.usersList);
        blockObject.model.ccEmailTag = CommonDataSource.formattingEmailAddress(ccEmailTag, this.emailTagsList, this.usersList);
        blockObject.model.bccEmailTag = CommonDataSource.formattingEmailAddress(bccEmailTag, this.emailTagsList, this.usersList);
        if (this.isConditional) {
            blockObject['condition'] = condition;
            blockObject['isConditional'] = true;
        }
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    };
    EmailBlockWidgetComponent.prototype.closeModal = function () {
        this.close.emit({
            action: 'close',
            data: null
        });
    };
    EmailBlockWidgetComponent.prototype.remove = function () {
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    };
    EmailBlockWidgetComponent.prototype.makeEmailAddressDropdownData = function () {
        var inputModel = this.inputModel;
        var _toEmailTag = CommonDataSource.makeEmailAddressDropdownData(inputModel.toEmailTag);
        this.selectedEmailInputs['toEmailTag'] = _toEmailTag['inputValue'];
        if (_toEmailTag['customList'].length) {
            this.emailCustomList = _toEmailTag['customList'];
        }
        var _ccEmailTag = CommonDataSource.makeEmailAddressDropdownData(inputModel.ccEmailTag);
        this.selectedEmailInputs['ccEmailTag'] = _ccEmailTag['inputValue'];
        if (_ccEmailTag['customList'].length) {
            this.emailCustomList = _ccEmailTag['customList'];
        }
        var _bccEmailTag = CommonDataSource.makeEmailAddressDropdownData(inputModel.bccEmailTag);
        this.selectedEmailInputs['bccEmailTag'] = _bccEmailTag['inputValue'];
        if (_bccEmailTag['customList'].length) {
            this.emailCustomList = _bccEmailTag['customList'];
        }
    };
    return EmailBlockWidgetComponent;
}());
export { EmailBlockWidgetComponent };
